var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var ScormController = {
    /*****************************************************************************************************
        * Is using route "api/scorm/info/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {ScormInfo}
    ******************************************************************************************************/
    GetInfo: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/scorm/info/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/scorm/content/{id}/{n1?}/{n2?}/{n3?}/{n4?}/{n5?}/{n6?}/{n7?}/{n8?}/{n9?}/{n10?}/{n11?}/{n12?}/{n13?}/{n14?}/{n15?}/{n16?}/{n17?}/{n18?}/{n19?}/{n20?}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @param {string} n1
        * @param {string} n2
        * @param {string} n3
        * @param {string} n4
        * @param {string} n5
        * @param {string} n6
        * @param {string} n7
        * @param {string} n8
        * @param {string} n9
        * @param {string} n10
        * @param {string} n11
        * @param {string} n12
        * @param {string} n13
        * @param {string} n14
        * @param {string} n15
        * @param {string} n16
        * @param {string} n17
        * @param {string} n18
        * @param {string} n19
        * @param {string} n20
        * @returns {void}
    ******************************************************************************************************/
    GetContent: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/scorm/content/{id}/{n1?}/{n2?}/{n3?}/{n4?}/{n5?}/{n6?}/{n7?}/{n8?}/{n9?}/{n10?}/{n11?}/{n12?}/{n13?}/{n14?}/{n15?}/{n16?}/{n17?}/{n18?}/{n19?}/{n20?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/scorm/registered" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<ScormRegistrationDownloadDto, string>}
    ******************************************************************************************************/
    GetRegistrations: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/scorm/registered", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.token
        });
    },
    /*****************************************************************************************************
        * Is using route "api/scorm/state" and http method "POST" to call the back-end.
    
        * @param {string[]} ids
        * @returns {ScormRegistrationState[]}
    ******************************************************************************************************/
    GetState: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("ids", JSON.stringify(data.ids));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/scorm/state", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/scorm/register/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {ScormRegistrationDownloadDto}
    ******************************************************************************************************/
    GetRegistration: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/scorm/register/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/scorm/register/forPlaylist" and http method "POST" to call the back-end.
    
        * @param {string} courseId
        * @param {string} playlistStateId
        * @param {string} metaData
        * @returns {ScormRegistrationDownloadDto}
    ******************************************************************************************************/
    CreateOrGetRegistration: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("courseId", JSON.stringify(data.courseId));
        fd.append("playlistStateId", JSON.stringify(data.playlistStateId));
        if (data.metaData !== undefined)
            fd.append("metaData", JSON.stringify(data.metaData));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/scorm/register/forPlaylist", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/scorm/register" and http method "POST" to call the back-end.
    
        * @param {string} userId
        * @param {string} courseId
        * @returns {ScormRegistrationDownloadDto}
    ******************************************************************************************************/
    RegisterForCourse: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("userId", JSON.stringify(data.userId));
        fd.append("courseId", JSON.stringify(data.courseId));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/scorm/register", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/scorm/register/all" and http method "POST" to call the back-end.
    
        * @returns {ScormRegistrationDownloadDto[]}
    ******************************************************************************************************/
    RegisterForAllCourses: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/scorm/register/all", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/scorm/registration/init" and http method "POST" to call the back-end.
    
        * @param {string} regId
        * @param {ScormApiVerion} apiVersion
        * @returns {ScormRegistrationEntryDownloadDto}
    ******************************************************************************************************/
    RegistrationInitialize: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("regId", JSON.stringify(data.regId));
        fd.append("apiVersion", JSON.stringify(data.apiVersion));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/scorm/registration/init", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/scorm/registration/finish" and http method "POST" to call the back-end.
    
        * @param {string} regEntryId
        * @returns {ScormRegistrationEntryDownloadDto}
    ******************************************************************************************************/
    RegistrationFinish: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("regEntryId", JSON.stringify(data.regEntryId));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/scorm/registration/finish", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/scorm/registration/commit" and http method "POST" to call the back-end.
    
        * @param {string} regEntryId
        * @param {any} data
        * @returns {ScormRegistrationEntryDownloadDto}
    ******************************************************************************************************/
    RegistrationCommit: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("regEntryId", JSON.stringify(data.regEntryId));
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/scorm/registration/commit", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=ScormController.js.map